"use strict";
/**
 * BDO API Client
 * Handles communication with Polish Waste Database (Baza Danych o Odpadach)
 *
 * Features:
 * - Token management with automatic refresh
 * - KEO (Waste Record Cards) operations
 * - KPO (Waste Transfer Cards) operations
 * - EUP (Waste Collection Points) management
 * - Application Insights telemetry (optional)
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BdoApiClient = void 0;
var applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
var endpoints_1 = require("../config/endpoints");
/**
 * Default localization function (returns keys as-is)
 */
var defaultLocalization = function (key) { return key; };
var BdoApiClient = /** @class */ (function () {
    function BdoApiClient(config, localizationFn) {
        var _a, _b, _c;
        this.config = config;
        this.accessToken = null;
        this.tokenType = null;
        this.tokenTime = 0;
        this.expiresIn = null;
        this.eupId = null;
        this.localize = localizationFn || defaultLocalization;
        this.maxRetries = (_a = config.maxRetries) !== null && _a !== void 0 ? _a : 3;
        this.retryDelay = (_b = config.retryDelay) !== null && _b !== void 0 ? _b : 500;
        if ((_c = config.appInsights) === null || _c === void 0 ? void 0 : _c.instrumentationKey) {
            this.appInsights = new applicationinsights_web_1.ApplicationInsights({
                config: {
                    instrumentationKey: config.appInsights.instrumentationKey
                }
            });
            this.appInsights.loadAppInsights();
        }
    }
    /**
     * Get BDO authentication token
     */
    BdoApiClient.prototype.getBdoToken = function (clientId, clientSecret, eupid) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, error_1;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 3, , 4]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetToken_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.Token,
                                eupid: eupid,
                                origin: typeof window !== 'undefined' ? window.location.origin : 'server'
                            }
                        });
                        return [4 /*yield*/, fetch(endpoints_1.BdoEndpoints.Token, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ clientId: clientId, clientSecret: clientSecret, eupid: eupid }),
                            })];
                    case 1:
                        response = _f.sent();
                        if (!response.ok) {
                            (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                                name: 'BdoApi_GetToken_HttpError',
                                properties: {
                                    status: response.status.toString(),
                                    statusText: response.statusText,
                                    endpoint: endpoints_1.BdoEndpoints.Token,
                                    eupid: eupid
                                }
                            });
                            throw new Error(this.localize('bdo_error_token_fetch'));
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _f.sent();
                        // Update token state
                        this.accessToken = data.AccessToken;
                        this.tokenType = data.TokenType;
                        this.eupId = eupid;
                        this.tokenTime = new Date().getTime();
                        this.expiresIn = data.ExpiresIn;
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetToken_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.Token,
                                eupid: eupid,
                                expiresIn: ((_d = data.ExpiresIn) === null || _d === void 0 ? void 0 : _d.toString()) || 'unknown'
                            }
                        });
                        return [2 /*return*/, data.AccessToken];
                    case 3:
                        error_1 = _f.sent();
                        (_e = this.appInsights) === null || _e === void 0 ? void 0 : _e.trackException({
                            exception: error_1,
                            properties: {
                                method: 'getBdoToken',
                                endpoint: endpoints_1.BdoEndpoints.Token,
                                eupid: eupid,
                                errorType: error_1.name || 'unknown'
                            }
                        });
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Reset token state (useful for logout or testing)
     */
    BdoApiClient.prototype.resetTokenState = function () {
        this.accessToken = null;
        this.tokenType = null;
        this.tokenTime = new Date().getTime();
        this.expiresIn = null;
        this.eupId = null;
    };
    /**
     * Get access token (read-only)
     */
    BdoApiClient.prototype.getAccessToken = function () {
        return this.accessToken;
    };
    /**
     * Get token type (read-only)
     */
    BdoApiClient.prototype.getTokenType = function () {
        return this.tokenType;
    };
    /**
     * Get token expiration time in seconds (read-only)
     */
    BdoApiClient.prototype.getExpiresIn = function () {
        return this.expiresIn;
    };
    /**
     * Check and refresh token if needed
     */
    BdoApiClient.prototype.checkAndRefreshToken = function (clientId, clientSecret, eupid) {
        return __awaiter(this, void 0, void 0, function () {
            var currentTime;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentTime = new Date().getTime();
                        // Check if token is valid and for correct EUP
                        if (this.accessToken &&
                            this.tokenType &&
                            this.expiresIn &&
                            (currentTime - this.tokenTime) < (this.expiresIn * 1000) &&
                            this.eupId === eupid) {
                            return [2 /*return*/, this.accessToken];
                        }
                        return [4 /*yield*/, this.getBdoToken(clientId, clientSecret, eupid)];
                    case 1: 
                    // Token expired or for different EUP - get new one
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get list of EUP IDs (without token)
     */
    BdoApiClient.prototype.getEupIdsWithOutToken = function (clientId_1, clientSecret_1) {
        return __awaiter(this, arguments, void 0, function (clientId, clientSecret, pageNumber, pageSize) {
            var requestBody, response, errorBody, result, error_2;
            var _a, _b, _c, _d, _e, _f;
            if (pageNumber === void 0) { pageNumber = 1; }
            if (pageSize === void 0) { pageSize = 100; }
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 5, , 6]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetEupIds_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.GetEupIds,
                                pageNumber: pageNumber.toString(),
                                pageSize: pageSize.toString(),
                                origin: typeof window !== 'undefined' ? window.location.origin : 'server'
                            }
                        });
                        requestBody = {
                            ClientId: clientId,
                            ClientSecret: clientSecret,
                            PaginationParameters: {
                                Order: {
                                    IsAscending: true
                                },
                                Page: {
                                    Index: pageNumber,
                                    Size: pageSize
                                }
                            }
                        };
                        return [4 /*yield*/, fetch(endpoints_1.BdoEndpoints.GetEupIds, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(requestBody),
                            })];
                    case 1:
                        response = _g.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 2:
                        errorBody = _g.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_GetEupIds_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.GetEupIds,
                                pageNumber: pageNumber.toString(),
                                pageSize: pageSize.toString()
                            }
                        });
                        if (response.status === 401) {
                            throw new Error(this.localize('bdo_error_invalid_credentials'));
                        }
                        throw new Error(this.localize('bdo_error_eupids_fetch'));
                    case 3: return [4 /*yield*/, response.json()];
                    case 4:
                        result = _g.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetEupIds_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.GetEupIds,
                                pageNumber: pageNumber.toString(),
                                pageSize: pageSize.toString(),
                                resultCount: ((_e = (_d = result === null || result === void 0 ? void 0 : result.items) === null || _d === void 0 ? void 0 : _d.length) === null || _e === void 0 ? void 0 : _e.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, result];
                    case 5:
                        error_2 = _g.sent();
                        (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackException({
                            exception: error_2,
                            properties: {
                                method: 'getEupIdsWithOutToken',
                                endpoint: endpoints_1.BdoEndpoints.GetEupIds,
                                pageNumber: pageNumber.toString(),
                                pageSize: pageSize.toString(),
                                errorType: error_2.name || 'unknown'
                            }
                        });
                        throw error_2;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get EUP IDs (alternative method)
     */
    BdoApiClient.prototype.getEupIds = function (clientId, clientSecret) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, err_1;
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 3, , 4]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetEupIds_Alternative_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.GetEupIds,
                                origin: typeof window !== 'undefined' ? window.location.origin : 'server'
                            }
                        });
                        return [4 /*yield*/, fetch(endpoints_1.BdoEndpoints.GetEupIds, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    clientId: clientId,
                                    clientSecret: clientSecret,
                                    PaginationParameters: {
                                        Order: {
                                            IsAscending: true
                                        },
                                        Page: {
                                            Index: 1,
                                            Size: 100
                                        }
                                    }
                                }),
                            })];
                    case 1:
                        response = _g.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _g.sent();
                        if (!response.ok) {
                            (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                                name: 'BdoApi_GetEupIds_Alternative_HttpError',
                                properties: {
                                    status: response.status.toString(),
                                    statusText: response.statusText,
                                    endpoint: endpoints_1.BdoEndpoints.GetEupIds,
                                    errorMessage: (data === null || data === void 0 ? void 0 : data.message) || 'unknown'
                                }
                            });
                            return [2 /*return*/, {
                                    data: null,
                                    error: (data === null || data === void 0 ? void 0 : data.message) || this.localize('bdo_error_eupids_fetch')
                                }];
                        }
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetEupIds_Alternative_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.GetEupIds,
                                resultCount: ((_e = (_d = data === null || data === void 0 ? void 0 : data.items) === null || _d === void 0 ? void 0 : _d.length) === null || _e === void 0 ? void 0 : _e.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, {
                                data: data,
                                error: null
                            }];
                    case 3:
                        err_1 = _g.sent();
                        (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackException({
                            exception: err_1,
                            properties: {
                                method: 'getEupIds',
                                endpoint: endpoints_1.BdoEndpoints.GetEupIds,
                                errorType: err_1.name || 'unknown'
                            }
                        });
                        return [2 /*return*/, {
                                data: null,
                                error: err_1.message || this.localize('bdo_error_connection')
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Find EUP ID and isActive status by identification number
     */
    BdoApiClient.prototype.findEupIdAndIsActive = function (clientId, clientSecret, identificationNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, data, error, found, error_3;
            var _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _j.trys.push([0, 2, , 3]);
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_FindEupId_Started',
                            properties: {
                                identificationNumber: identificationNumber,
                                origin: typeof window !== 'undefined' ? window.location.origin : 'server'
                            }
                        });
                        return [4 /*yield*/, this.getEupIds(clientId, clientSecret)];
                    case 1:
                        _a = _j.sent(), data = _a.data, error = _a.error;
                        if (error) {
                            (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                                name: 'BdoApi_FindEupId_GetEupIdsError',
                                properties: {
                                    identificationNumber: identificationNumber,
                                    error: error
                                }
                            });
                            return [2 /*return*/, { eupId: null, isActive: null, error: error }];
                        }
                        if (!(data === null || data === void 0 ? void 0 : data.items) || !Array.isArray(data.items)) {
                            (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackEvent({
                                name: 'BdoApi_FindEupId_NoDataFound',
                                properties: {
                                    identificationNumber: identificationNumber,
                                    hasData: !!data,
                                    hasItems: !!(data === null || data === void 0 ? void 0 : data.items),
                                    isArray: Array.isArray(data === null || data === void 0 ? void 0 : data.items)
                                }
                            });
                            return [2 /*return*/, { eupId: null, isActive: null, error: this.localize('bdo_error_eupids_not_found') }];
                        }
                        found = data.items.find(function (item) { return item.identificationNumber === identificationNumber; });
                        if (!found) {
                            (_e = this.appInsights) === null || _e === void 0 ? void 0 : _e.trackEvent({
                                name: 'BdoApi_FindEupId_NotFound',
                                properties: {
                                    identificationNumber: identificationNumber,
                                    totalItemsCount: data.items.length.toString()
                                }
                            });
                            return [2 /*return*/, { eupId: null, isActive: null, error: this.localize('bdo_error_eupids_empty') }];
                        }
                        (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackEvent({
                            name: 'BdoApi_FindEupId_Success',
                            properties: {
                                identificationNumber: identificationNumber,
                                eupId: found.eupId,
                                isActive: ((_g = found.isActive) === null || _g === void 0 ? void 0 : _g.toString()) || 'unknown'
                            }
                        });
                        return [2 /*return*/, {
                                eupId: found.eupId,
                                isActive: found.isActive,
                                error: null
                            }];
                    case 2:
                        error_3 = _j.sent();
                        (_h = this.appInsights) === null || _h === void 0 ? void 0 : _h.trackException({
                            exception: error_3,
                            properties: {
                                method: 'findEupIdAndIsActive',
                                identificationNumber: identificationNumber,
                                errorType: error_3.name || 'unknown'
                            }
                        });
                        return [2 /*return*/, { eupId: null, isActive: null, error: this.localize('bdo_error_connection') }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BdoApiClient.prototype.formatDate = function (date) {
        return date.toISOString().slice(0, 10); // "yyyy-MM-dd"
    };
    /**
     * Helper method to retry requests with exponential backoff for 429 errors
     */
    BdoApiClient.prototype.retryWithBackoff = function (requestFn, context) {
        return __awaiter(this, void 0, void 0, function () {
            var lastError, attempt, response, delay, error_4, delay;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        lastError = null;
                        attempt = 0;
                        _b.label = 1;
                    case 1:
                        if (!(attempt <= this.maxRetries)) return [3 /*break*/, 10];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 6, , 9]);
                        return [4 /*yield*/, requestFn()];
                    case 3:
                        response = _b.sent();
                        // If not 429, return response (success or other error)
                        if (response.status !== 429) {
                            return [2 /*return*/, response];
                        }
                        if (!(attempt < this.maxRetries)) return [3 /*break*/, 5];
                        delay = this.retryDelay * (attempt + 1);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_RateLimited_Retry',
                            properties: {
                                context: context,
                                attempt: (attempt + 1).toString(),
                                maxRetries: this.maxRetries.toString(),
                                delayMs: delay.toString(),
                                status: '429'
                            }
                        });
                        console.warn("Rate limited (429). Retrying ".concat(context, " in ").concat(delay, "ms (attempt ").concat(attempt + 1, "/").concat(this.maxRetries, ")..."));
                        return [4 /*yield*/, this.sleep(delay)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 5:
                        // Last attempt also got 429
                        lastError = new Error("Rate limit exceeded after ".concat(this.maxRetries, " retries"));
                        return [3 /*break*/, 10];
                    case 6:
                        error_4 = _b.sent();
                        lastError = error_4;
                        if (!(attempt < this.maxRetries)) return [3 /*break*/, 8];
                        delay = this.retryDelay * (attempt + 1);
                        console.warn("Network error in ".concat(context, ". Retrying in ").concat(delay, "ms (attempt ").concat(attempt + 1, "/").concat(this.maxRetries, ")..."));
                        return [4 /*yield*/, this.sleep(delay)];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        attempt++;
                        return [3 /*break*/, 1];
                    case 10: throw lastError || new Error('Request failed after retries');
                }
            });
        });
    };
    /**
     * Sleep helper for delays
     */
    BdoApiClient.prototype.sleep = function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    /**
     * Get KPO (Waste Transfer Card) data
     */
    BdoApiClient.prototype.getKpoData = function (clientId_1, clientSecret_1, eupid_1) {
        return __awaiter(this, arguments, void 0, function (clientId, clientSecret, eupid, PageIndex, PageSize, DateFrom, DateTo) {
            var token_1, payload_1, response, errorBody, result, error_5;
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            if (PageIndex === void 0) { PageIndex = 1; }
            if (PageSize === void 0) { PageSize = 50; }
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetKpoData_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKpo,
                                eupid: eupid,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                dateFrom: DateFrom ? this.formatDate(DateFrom) : 'not_specified',
                                dateTo: DateTo ? this.formatDate(DateTo) : 'not_specified'
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_1 = _g.sent();
                        payload_1 = {
                            PaginationParameters: {
                                Order: {
                                    IsAscending: true,
                                    OrderColumn: "CardNumber"
                                },
                                Page: {
                                    Index: PageIndex,
                                    Size: PageSize
                                }
                            },
                            SearchInCarriers: true,
                            SearchInReceivers: false,
                            TransportDateRange: true,
                            TransportDateFrom: DateFrom ? this.formatDate(DateFrom) : undefined,
                            TransportDateTo: DateTo ? this.formatDate(DateTo) : undefined,
                            ReceiveConfirmationDateRange: true,
                            ReceiveConfirmationDateFrom: DateFrom ? this.formatDate(DateFrom) : undefined,
                            ReceiveConfirmationDateTo: DateTo ? this.formatDate(DateTo) : undefined,
                        };
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(endpoints_1.BdoEndpoints.SearchKpo, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_1),
                                },
                                body: JSON.stringify(payload_1),
                            }); }, "getKpoData(page:".concat(PageIndex, ")"))];
                    case 2:
                        response = _g.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 3:
                        errorBody = _g.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_GetKpoData_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.SearchKpo,
                                eupid: eupid,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        throw new Error(this.localize('bdo_error_kpo_fetch'));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        result = _g.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetKpoData_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKpo,
                                eupid: eupid,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                resultCount: ((_e = (_d = result === null || result === void 0 ? void 0 : result.items) === null || _d === void 0 ? void 0 : _d.length) === null || _e === void 0 ? void 0 : _e.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, result];
                    case 6:
                        error_5 = _g.sent();
                        (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackException({
                            exception: error_5,
                            properties: {
                                method: 'getKpoData',
                                endpoint: endpoints_1.BdoEndpoints.SearchKpo,
                                eupid: eupid,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                errorType: error_5.name || 'unknown'
                            }
                        });
                        throw error_5;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all KPO cards for a specific year
     */
    BdoApiClient.prototype.getAllKpoInYearData = function (clientId_1, clientSecret_1, eupid_1, Year_1) {
        return __awaiter(this, arguments, void 0, function (clientId, clientSecret, eupid, Year, PageIndex, PageSize) {
            var token_2, year, payload_2, response, errorBody, result, error_6;
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            if (PageIndex === void 0) { PageIndex = 1; }
            if (PageSize === void 0) { PageSize = 50; }
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetAllKpoInYear_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKpo,
                                eupid: eupid,
                                year: Year.toString(),
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_2 = _g.sent();
                        year = Year || new Date().getFullYear();
                        payload_2 = {
                            PaginationParameters: {
                                Order: {
                                    IsAscending: true,
                                    OrderColumn: "CardNumber"
                                },
                                Page: {
                                    Index: PageIndex,
                                    Size: PageSize
                                }
                            },
                            Year: year,
                            SearchInCarriers: true,
                            SearchInReceivers: false,
                            TransportDateRange: false,
                            ReceiveConfirmationDateRange: false
                        };
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(endpoints_1.BdoEndpoints.SearchKpo, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_2),
                                },
                                body: JSON.stringify(payload_2),
                            }); }, "getAllKpoInYearData(year:".concat(year, ",page:").concat(PageIndex, ")"))];
                    case 2:
                        response = _g.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 3:
                        errorBody = _g.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_GetAllKpoInYear_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.SearchKpo,
                                eupid: eupid,
                                year: year.toString(),
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        throw new Error(this.localize('bdo_error_kpo_fetch'));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        result = _g.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetAllKpoInYear_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKpo,
                                eupid: eupid,
                                year: year.toString(),
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                resultCount: ((_e = (_d = result === null || result === void 0 ? void 0 : result.items) === null || _d === void 0 ? void 0 : _d.length) === null || _e === void 0 ? void 0 : _e.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, result];
                    case 6:
                        error_6 = _g.sent();
                        (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackException({
                            exception: error_6,
                            properties: {
                                method: 'getAllKpoInYearData',
                                endpoint: endpoints_1.BdoEndpoints.SearchKpo,
                                eupid: eupid,
                                year: Year.toString(),
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                errorType: error_6.name || 'unknown'
                            }
                        });
                        throw error_6;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get KPO printing page data
     * eupType.clientId, eupType.clientSecret, kpoCard.cardNumber, eupType.eupId, kpoCard.kpoId
     */
    BdoApiClient.prototype.getKpoPrintingPage = function (clientId, clientSecret, cardNumber, eupid, kpoId) {
        return __awaiter(this, void 0, void 0, function () {
            var token_3, url_1, response, result, error_7;
            var _this = this;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 4, , 5]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetKpoPrintingPage_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.KpoPrintingPage,
                                cardNumber: cardNumber,
                                kpoId: kpoId,
                                eupid: eupid
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_3 = _e.sent();
                        url_1 = "".concat(endpoints_1.BdoEndpoints.KpoPrintingPage, "?KpoId=").concat(kpoId);
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(url_1, {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_3),
                                },
                            }); }, "getKpoPrintingPage(".concat(cardNumber, ")"))];
                    case 2:
                        response = _e.sent();
                        if (!response.ok) {
                            (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                                name: 'BdoApi_GetKpoPrintingPage_HttpError',
                                properties: {
                                    status: response.status.toString(),
                                    statusText: response.statusText,
                                    endpoint: url_1,
                                    cardNumber: cardNumber,
                                    kpoId: kpoId,
                                    eupid: eupid
                                }
                            });
                            throw new Error(this.localize('bdo_error_kpo_printing') + ': ' + cardNumber);
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _e.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetKpoPrintingPage_Success',
                            properties: {
                                endpoint: url_1,
                                cardNumber: cardNumber,
                                kpoId: kpoId,
                                eupid: eupid,
                                hasResult: !!result
                            }
                        });
                        return [2 /*return*/, result];
                    case 4:
                        error_7 = _e.sent();
                        (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackException({
                            exception: error_7,
                            properties: {
                                method: 'getKpoPrintingPage',
                                endpoint: endpoints_1.BdoEndpoints.KpoPrintingPage,
                                cardNumber: cardNumber,
                                kpoId: kpoId,
                                eupid: eupid,
                                errorType: error_7.name || 'unknown'
                            }
                        });
                        throw error_7;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get KEO (Waste Record Card) data
     */
    BdoApiClient.prototype.getKeoData = function (clientId_1, clientSecret_1, eupid_1) {
        return __awaiter(this, arguments, void 0, function (clientId, clientSecret, eupid, PageIndex, PageSize, Year) {
            var token_4, year, payload_3, response, errorBody, result, error_8;
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            if (PageIndex === void 0) { PageIndex = 1; }
            if (PageSize === void 0) { PageSize = 50; }
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetKeoData_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKeo,
                                eupid: eupid,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                year: (Year === null || Year === void 0 ? void 0 : Year.toString()) || 'current_year'
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_4 = _g.sent();
                        year = Year || new Date().getFullYear();
                        payload_3 = {
                            PaginationParameters: {
                                Order: {
                                    IsAscending: true,
                                    OrderColumn: "CardNumber"
                                },
                                Page: {
                                    Index: PageIndex,
                                    Size: PageSize
                                }
                            },
                            Year: year,
                        };
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(endpoints_1.BdoEndpoints.SearchKeo, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_4),
                                },
                                body: JSON.stringify(payload_3),
                            }); }, "getKeoData(year:".concat(year, ",page:").concat(PageIndex, ")"))];
                    case 2:
                        response = _g.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 3:
                        errorBody = _g.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_GetKeoData_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.SearchKeo,
                                eupid: eupid,
                                year: year.toString(),
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        throw new Error(this.localize('bdo_error_keo_fetch'));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        result = _g.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetKeoData_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKeo,
                                eupid: eupid,
                                year: year.toString(),
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                resultCount: ((_e = (_d = result === null || result === void 0 ? void 0 : result.items) === null || _d === void 0 ? void 0 : _d.length) === null || _e === void 0 ? void 0 : _e.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, result];
                    case 6:
                        error_8 = _g.sent();
                        (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackException({
                            exception: error_8,
                            properties: {
                                method: 'getKeoData',
                                endpoint: endpoints_1.BdoEndpoints.SearchKeo,
                                eupid: eupid,
                                year: (Year === null || Year === void 0 ? void 0 : Year.toString()) || 'current_year',
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                errorType: error_8.name || 'unknown'
                            }
                        });
                        throw error_8;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get KEO generated waste data
     */
    BdoApiClient.prototype.getKeoGeneratedData = function (clientId_1, clientSecret_1, eupid_1, KeoId_1) {
        return __awaiter(this, arguments, void 0, function (clientId, clientSecret, eupid, KeoId, PageIndex, PageSize) {
            var token_5, payload_4, response, errorBody, result, error_9;
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            if (PageIndex === void 0) { PageIndex = 1; }
            if (PageSize === void 0) { PageSize = 50; }
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetKeoGeneratedData_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoGenerated,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_5 = _g.sent();
                        payload_4 = {
                            PaginationParameters: {
                                Order: {
                                    IsAscending: true,
                                    OrderColumn: "ManufactureDate"
                                },
                                Page: {
                                    Index: PageIndex,
                                    Size: PageSize
                                }
                            },
                            KeoId: KeoId,
                        };
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(endpoints_1.BdoEndpoints.SearchKeoGenerated, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_5),
                                },
                                body: JSON.stringify(payload_4),
                            }); }, "getKeoGeneratedData(keoId:".concat(KeoId, ",page:").concat(PageIndex, ")"))];
                    case 2:
                        response = _g.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 3:
                        errorBody = _g.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_GetKeoGeneratedData_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoGenerated,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        throw new Error(this.localize('bdo_error_keo_generated'));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        result = _g.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetKeoGeneratedData_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoGenerated,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                resultCount: ((_e = (_d = result === null || result === void 0 ? void 0 : result.items) === null || _d === void 0 ? void 0 : _d.length) === null || _e === void 0 ? void 0 : _e.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, result];
                    case 6:
                        error_9 = _g.sent();
                        (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackException({
                            exception: error_9,
                            properties: {
                                method: 'getKeoGeneratedData',
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoGenerated,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                errorType: error_9.name || 'unknown'
                            }
                        });
                        throw error_9;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get KEO treated waste data
     */
    BdoApiClient.prototype.getKeoTreatedData = function (clientId_1, clientSecret_1, eupid_1, KeoId_1) {
        return __awaiter(this, arguments, void 0, function (clientId, clientSecret, eupid, KeoId, PageIndex, PageSize) {
            var token_6, payload_5, response, errorBody, result, error_10;
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            if (PageIndex === void 0) { PageIndex = 1; }
            if (PageSize === void 0) { PageSize = 50; }
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetKeoTreatedData_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoTreated,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_6 = _g.sent();
                        payload_5 = {
                            PaginationParameters: {
                                Order: {
                                    IsAscending: true,
                                    OrderColumn: "WasteRecycleTime"
                                },
                                Page: {
                                    Index: PageIndex,
                                    Size: PageSize
                                }
                            },
                            KeoId: KeoId,
                        };
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(endpoints_1.BdoEndpoints.SearchKeoTreated, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_6),
                                },
                                body: JSON.stringify(payload_5),
                            }); }, "getKeoTreatedData(keoId:".concat(KeoId, ",page:").concat(PageIndex, ")"))];
                    case 2:
                        response = _g.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 3:
                        errorBody = _g.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_GetKeoTreatedData_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoTreated,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        throw new Error(this.localize('bdo_error_keo_treated'));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        result = _g.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetKeoTreatedData_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoTreated,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                resultCount: ((_e = (_d = result === null || result === void 0 ? void 0 : result.items) === null || _d === void 0 ? void 0 : _d.length) === null || _e === void 0 ? void 0 : _e.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, result];
                    case 6:
                        error_10 = _g.sent();
                        (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackException({
                            exception: error_10,
                            properties: {
                                method: 'getKeoTreatedData',
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoTreated,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                errorType: error_10.name || 'unknown'
                            }
                        });
                        throw error_10;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get KEO forwarded waste data
     */
    BdoApiClient.prototype.getKeoForwardedData = function (clientId_1, clientSecret_1, eupid_1, KeoId_1) {
        return __awaiter(this, arguments, void 0, function (clientId, clientSecret, eupid, KeoId, PageIndex, PageSize) {
            var token_7, payload_6, response, errorBody, result, error_11;
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            if (PageIndex === void 0) { PageIndex = 1; }
            if (PageSize === void 0) { PageSize = 50; }
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetKeoForwardedData_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoForwarded,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_7 = _g.sent();
                        payload_6 = {
                            PaginationParameters: {
                                Order: {
                                    IsAscending: true,
                                    OrderColumn: "CardNumberKpo"
                                },
                                Page: {
                                    Index: PageIndex,
                                    Size: PageSize
                                }
                            },
                            KeoId: KeoId,
                        };
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(endpoints_1.BdoEndpoints.SearchKeoForwarded, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_7),
                                },
                                body: JSON.stringify(payload_6),
                            }); }, "getKeoForwardedData(keoId:".concat(KeoId, ",page:").concat(PageIndex, ")"))];
                    case 2:
                        response = _g.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 3:
                        errorBody = _g.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_GetKeoForwardedData_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoForwarded,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString()
                            }
                        });
                        throw new Error(this.localize('bdo_error_keo_forwarded'));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        result = _g.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetKeoForwardedData_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoForwarded,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                resultCount: ((_e = (_d = result === null || result === void 0 ? void 0 : result.items) === null || _d === void 0 ? void 0 : _d.length) === null || _e === void 0 ? void 0 : _e.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, result];
                    case 6:
                        error_11 = _g.sent();
                        (_f = this.appInsights) === null || _f === void 0 ? void 0 : _f.trackException({
                            exception: error_11,
                            properties: {
                                method: 'getKeoForwardedData',
                                endpoint: endpoints_1.BdoEndpoints.SearchKeoForwarded,
                                eupid: eupid,
                                keoId: KeoId,
                                pageIndex: PageIndex.toString(),
                                pageSize: PageSize.toString(),
                                errorType: error_11.name || 'unknown'
                            }
                        });
                        throw error_11;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // getKeoPrintingPage(eupType.clientId, eupType.clientSecret, cardNumber, eupType.eupId, keoId)
    BdoApiClient.prototype.getKeoPrintingPage = function (clientId, clientSecret, cardNumber, eupid, keoId) {
        return __awaiter(this, void 0, void 0, function () {
            var token_8, url_2, response, result, error_12;
            var _this = this;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 4, , 5]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_GetKeoPrintingPage_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.KeoPrintingPage,
                                cardNumber: cardNumber,
                                keoId: keoId,
                                eupid: eupid
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_8 = _e.sent();
                        url_2 = "".concat(endpoints_1.BdoEndpoints.KeoPrintingPage, "?KeoId=").concat(keoId);
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(url_2, {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_8),
                                },
                            }); }, "getKeoPrintingPage(".concat(cardNumber, ")"))];
                    case 2:
                        response = _e.sent();
                        if (!response.ok) {
                            (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                                name: 'BdoApi_GetKeoPrintingPage_HttpError',
                                properties: {
                                    status: response.status.toString(),
                                    statusText: response.statusText,
                                    endpoint: url_2,
                                    cardNumber: cardNumber,
                                    keoId: keoId,
                                    eupid: eupid
                                }
                            });
                            throw new Error(this.localize('bdo_error_keo_printing') + ': ' + cardNumber);
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _e.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_GetKeoPrintingPage_Success',
                            properties: {
                                endpoint: url_2,
                                cardNumber: cardNumber,
                                keoId: keoId,
                                eupid: eupid,
                                hasResult: !!result
                            }
                        });
                        return [2 /*return*/, result];
                    case 4:
                        error_12 = _e.sent();
                        (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackException({
                            exception: error_12,
                            properties: {
                                method: 'getKeoPrintingPage',
                                endpoint: endpoints_1.BdoEndpoints.KeoPrintingPage,
                                cardNumber: cardNumber,
                                keoId: keoId,
                                eupid: eupid,
                                errorType: error_12.name || 'unknown'
                            }
                        });
                        throw error_12;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /** Document services */
    /**
     * Download KPO document as PDF
     * @param clientId - BDO client ID
     * @param clientSecret - BDO client secret
     * @param eupid - EUP ID
     * @param kpoId - KPO ID
     * @param filename - Name for the downloaded PDF file
     * @returns Base64 encoded PDF string
     */
    BdoApiClient.prototype.downloadKpoPdf = function (clientId, clientSecret, eupid, kpoId, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var token_9, url_3, response, errorBody, base64Pdf, error_13;
            var _this = this;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_DownloadKpoPdf_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKPOPrintingPage,
                                eupid: eupid,
                                kpoId: kpoId,
                                filename: filename
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_9 = _f.sent();
                        url_3 = "".concat(endpoints_1.BdoEndpoints.DocumentServiceKPOPrintingPage, "?KpoId=").concat(encodeURIComponent(kpoId));
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(url_3, {
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_9),
                                },
                            }); }, "downloadKpoPdf(kpoId:".concat(kpoId, ")"))];
                    case 2:
                        response = _f.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 3:
                        errorBody = _f.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_DownloadKpoPdf_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKPOPrintingPage,
                                eupid: eupid,
                                kpoId: kpoId
                            }
                        });
                        throw new Error(this.localize('bdo_error_kpo_pdf_download'));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        base64Pdf = _f.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_DownloadKpoPdf_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKPOPrintingPage,
                                eupid: eupid,
                                kpoId: kpoId,
                                filename: filename,
                                base64Length: ((_d = base64Pdf === null || base64Pdf === void 0 ? void 0 : base64Pdf.length) === null || _d === void 0 ? void 0 : _d.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, {
                                data: base64Pdf,
                                filename: filename,
                                error: null
                            }];
                    case 6:
                        error_13 = _f.sent();
                        (_e = this.appInsights) === null || _e === void 0 ? void 0 : _e.trackException({
                            exception: error_13,
                            properties: {
                                method: 'downloadKpoPdf',
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKPOPrintingPage,
                                eupid: eupid,
                                kpoId: kpoId,
                                filename: filename,
                                errorType: error_13.name || 'unknown'
                            }
                        });
                        return [2 /*return*/, {
                                data: null,
                                filename: filename,
                                error: error_13.message || this.localize('bdo_error_connection')
                            }];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
   * Download KPO document as PDF
   * @param clientId - BDO client ID
   * @param clientSecret - BDO client secret
   * @param eupid - EUP ID
   * @param kpoId - KPO ID
   * @param filename - Name for the downloaded PDF file
   * @returns Base64 encoded PDF string
   */
    BdoApiClient.prototype.downloadConfirmationKpoPdf = function (clientId, clientSecret, eupid, kpoId, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var token_10, url_4, response, errorBody, base64Pdf, error_14;
            var _this = this;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_DownloadConfirmationKpoPdf_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKPOConfirmation,
                                eupid: eupid,
                                kpoId: kpoId,
                                filename: filename
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_10 = _f.sent();
                        url_4 = "".concat(endpoints_1.BdoEndpoints.DocumentServiceKPOConfirmation, "?KpoId=").concat(encodeURIComponent(kpoId));
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(url_4, {
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_10),
                                },
                            }); }, "downloadConfirmationKpoPdf(kpoId:".concat(kpoId, ")"))];
                    case 2:
                        response = _f.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 3:
                        errorBody = _f.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_DownloadConfirmationKpoPdf_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKPOConfirmation,
                                eupid: eupid,
                                kpoId: kpoId
                            }
                        });
                        throw new Error(this.localize('bdo_error_kpo_pdf_download'));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        base64Pdf = _f.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_DownloadConfirmationKpoPdf_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKPOConfirmation,
                                eupid: eupid,
                                kpoId: kpoId,
                                filename: filename,
                                base64Length: ((_d = base64Pdf === null || base64Pdf === void 0 ? void 0 : base64Pdf.length) === null || _d === void 0 ? void 0 : _d.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, {
                                data: base64Pdf,
                                filename: filename,
                                error: null
                            }];
                    case 6:
                        error_14 = _f.sent();
                        (_e = this.appInsights) === null || _e === void 0 ? void 0 : _e.trackException({
                            exception: error_14,
                            properties: {
                                method: 'downloadConfirmationKpoPdf',
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKPOConfirmation,
                                eupid: eupid,
                                kpoId: kpoId,
                                filename: filename,
                                errorType: error_14.name || 'unknown'
                            }
                        });
                        return [2 /*return*/, {
                                data: null,
                                filename: filename,
                                error: error_14.message || this.localize('bdo_error_connection')
                            }];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
   * Download KEO document as PDF
   * @param clientId - BDO client ID
   * @param clientSecret - BDO client secret
   * @param eupid - EUP ID
   * @param keoId - KEO ID
   * @param filename - Name for the downloaded PDF file
   * @returns Base64 encoded PDF string
   */
    BdoApiClient.prototype.downloadKeoPdf = function (clientId, clientSecret, eupid, keoId, filename) {
        return __awaiter(this, void 0, void 0, function () {
            var token_11, url_5, response, errorBody, base64Pdf, error_15;
            var _this = this;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 6, , 7]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'BdoApi_DownloadKeoPdf_Started',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKEOPrintingPage,
                                eupid: eupid,
                                keoId: keoId,
                                filename: filename
                            }
                        });
                        return [4 /*yield*/, this.checkAndRefreshToken(clientId, clientSecret, eupid)];
                    case 1:
                        token_11 = _f.sent();
                        url_5 = "".concat(endpoints_1.BdoEndpoints.DocumentServiceKEOPrintingPage, "?KeoId=").concat(encodeURIComponent(keoId));
                        return [4 /*yield*/, this.retryWithBackoff(function () { return fetch(url_5, {
                                method: "GET",
                                headers: {
                                    Authorization: "".concat(_this.tokenType, " ").concat(token_11),
                                },
                            }); }, "downloadKeoPdf(keoId:".concat(keoId, ")"))];
                    case 2:
                        response = _f.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 3:
                        errorBody = _f.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'BdoApi_DownloadKpoPdf_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorBody: errorBody,
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKEOPrintingPage,
                                eupid: eupid,
                                keoId: keoId
                            }
                        });
                        throw new Error(this.localize('bdo_error_keo_pdf_download'));
                    case 4: return [4 /*yield*/, response.json()];
                    case 5:
                        base64Pdf = _f.sent();
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'BdoApi_DownloadKeoPdf_Success',
                            properties: {
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKEOPrintingPage,
                                eupid: eupid,
                                keoId: keoId,
                                filename: filename,
                                base64Length: ((_d = base64Pdf === null || base64Pdf === void 0 ? void 0 : base64Pdf.length) === null || _d === void 0 ? void 0 : _d.toString()) || '0'
                            }
                        });
                        return [2 /*return*/, {
                                data: base64Pdf,
                                filename: filename,
                                error: null
                            }];
                    case 6:
                        error_15 = _f.sent();
                        (_e = this.appInsights) === null || _e === void 0 ? void 0 : _e.trackException({
                            exception: error_15,
                            properties: {
                                method: 'downloadKeoPdf',
                                endpoint: endpoints_1.BdoEndpoints.DocumentServiceKEOPrintingPage,
                                eupid: eupid,
                                keoId: keoId,
                                filename: filename,
                                errorType: error_15.name || 'unknown'
                            }
                        });
                        return [2 /*return*/, {
                                data: null,
                                filename: filename,
                                error: error_15.message || this.localize('bdo_error_connection')
                            }];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return BdoApiClient;
}());
exports.BdoApiClient = BdoApiClient;
//# sourceMappingURL=BdoApiClient.js.map